import React, { useEffect, Suspense } from 'react';
import Axios from 'axios';
import { messaging} from '../firebase-config';
import { Head } from './partytown';
import CrispWidget from './crisp';
import FrillWidget from './frill';

// service worker
import * as serviceWorkerRegistration from '../serviceWorkerRegistration';

// components
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { PrivateRoute, AuthProvider } from './auth';
import { MobileNavProvider, View, WhitelabelProvider, Loader, MailCountsProvider } from 'components/lib';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

// 404
import { NotFound } from 'views/error/404';
import { CopilotProvider } from 'components/copilot/CopilotContext';
import CopilotPanel from 'components/copilot/CopilotPanel';
import { ActivationProvider } from 'components/activation/ActivationContext';
import ActivationWidget from 'components/activation/ActivationWidget';

// tailwind css
import '../css/output.css';
import { getToken } from 'firebase/messaging';
import { decodeJWT } from 'utils/jwtDecode';
import axios from 'axios';
import McpOauthBridge from './mcpOauthBridge';
import { LazyLoadErrorBoundary } from './lazyLoadErrorBoundary';
import { identifyUser } from '../analytics/posthog';

// settings
const Settings = require('settings.json');
const StripePromise = loadStripe(
  Settings[process.env.NODE_ENV].stripe.publishableAPIKey
).catch((err) => {
  console.warn('Stripe failed to load:', err.message);
  return null;
});

const routes = [
  ...require('routes/setup').default,
  ...require('routes/account').default,
  ...require('routes/app').default,
  ...require('routes/auth').default,
  ...require('routes/website').default,
];

// Register the service worker
serviceWorkerRegistration.register();

export default function App(props) {
  let user = JSON.parse(localStorage.getItem('user'));

  const addUsetifulScript = async () => {
    try {
      const userData = decodeJWT(user.token);
      const accountID = userData.account_id;
      let plan_name = null;
      let plan_duration = null;
      try {
        const accountData = (await axios.get(`/api/account`))?.data?.data;
        if (accountData) {
          plan_name = accountData?.plan;
          if (plan_name === "ltd") plan_duration = "lifetime";
          else if (plan_name === "Trial") {
            plan_duration = "trial";
            plan_name = "trial";
          } else {
            plan_name = "paid";
            if (accountData.subscription_data.plan.interval === "month") plan_duration = "monthly";
            else plan_duration = "yearly";
          }
          // PostHog: attach plan/account properties to the identified person
          identifyUser(userData, accountData);
        }
        console.log("Account data couldn't be found");
      } catch (error) {
        console.log("Error fetching account data", error?.response?.data?.message || error?.message);
      }
      const response = await axios.get('/api/whitelabel', { params: { accountID } });
      const data = response?.data?.data;
      if (
        Object.keys(data).length === 0 ||
        userData.permission === "owner" || 
        userData.permission === "admin"
      ) {
        const userIdentificationScript = document.createElement('script');
        userIdentificationScript.innerHTML = `
          window.usetifulTags = {
            userId: "${userData.userId}",
            fullName: "${userData.name}",
            email: "${userData.email}",
            plan_name: "${plan_name}",
            plan_duration: "${plan_duration}"
          };
        `;
        document.head.appendChild(userIdentificationScript);
    
        const usetifulScript = document.createElement('script');
        usetifulScript.async = true;
        usetifulScript.src = "https://www.usetiful.com/dist/usetiful.js";
        usetifulScript.setAttribute('id', 'usetifulScript');
        usetifulScript.dataset.token = "be338e4a169a9a3f8b3761326fcf27ee";
        document.head.appendChild(usetifulScript); 
      }
    } catch (error) {
      console.log("Error fetching whitelabel data to add usetiful", error);
    }
  }

  useEffect(() => {
    user = JSON.parse(localStorage.getItem('user'));
    if (
      user &&
      !user.isEmailVerified &&
      window.location.pathname !== "/verification" &&
      window.location.pathname !== "/onboarding" &&
      window.location.pathname !== "/magic"
    ) {
      window.location = "/verification";
      return;
    }

    if (user && user.account_id) {
      localStorage.removeItem("user")
      localStorage.removeItem("user_ip")
      localStorage.removeItem("newUser")
      window.location.reload()
      return
    }

    if (user) addUsetifulScript();

    const requestNotificationPermission = async () => {
      try {
        const permission = await Notification.requestPermission();
        if (permission === 'granted') {
          if (messaging) {
            const token = await getToken(messaging, {
              vapidKey: 'BEV6sxBw6kmSjXKiZU2pLlsaa0lnCJ9hyh-c3GZwh8Qw5dTqE0nSztKKUVFF-n6l-p758b7e7hdl7WTVLIxT9nE',
            });
            if (token) {
              // console.log("fpi toke", token)
              const data = {
                token 
              }
              await Axios({
                url: '/api/settokens',
                method: 'post',
                data
              });
            } else {
              await Notification.requestPermission();
            }
          }
        } else {
          // console.log('Notification permission denied.');
        }
      } catch (error) {
        // alert("If using Brave please go to brave://settings/privacy and enable Use Google services for push messaging")   
        // console.error('Error requesting permission or getting token:', error);
      }
    };

    requestNotificationPermission();

    let ipExist = localStorage.getItem('user_ip')
    if(!ipExist) getIP()
    else addIPtoAxios(JSON.parse(ipExist))

    // Read a cookie
    const readCookie = (name) => {
      const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
      if (match) return match[2];
      return null;
    };

    const _fbc = readCookie('_fbc');
    const _fbp = readCookie('_fbp');
    const _ga = readCookie('_ga');
    const gclid = readCookie('gclid');
    const gbraid = readCookie('gbraid');
    const wbraid = readCookie('wbraid');
    const ga_click_id = gclid || gbraid || wbraid
    const partnero_partner = readCookie('partnero_partner');

    addFBtoAxios(_fbc, _fbp, _ga, ga_click_id, partnero_partner)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // remove this before merging into main
  Axios.defaults.baseURL =
    process.env.NODE_ENV === 'production'
      ? window.location.origin
      : Settings[process.env.NODE_ENV].server_url;

  if (user?.token) {
    // add auth token to api header calls
    Axios.defaults.headers.common['Authorization'] = 'Bearer ' + user.token;
  }

  async function getIP() {
    try {
      let { data } = await Axios.get(`https://ipapi.co/json/`)
      // console.log("DATA ", data)
      localStorage.setItem('user_ip', JSON.stringify(data))
      addIPtoAxios(data)
    } catch (error) {
      // console.log("TEST ERR ", error)
    }
  }

  function addIPtoAxios(user_ip) {
    Axios.defaults.headers.common['X-User-IP'] = user_ip.ip;
    Axios.defaults.headers.common['X-User-Country'] = user_ip.country_code;
    Axios.defaults.headers.common['X-User-State'] = user_ip.region_code;
    Axios.defaults.headers.common['X-User-City'] = user_ip.city;
    Axios.defaults.headers.common['X-User-Zipcode'] = user_ip.postal;
    Axios.defaults.headers.common['X-User-Agent'] = navigator.userAgent
  }

  function addFBtoAxios(_fbc, _fbp, _ga, ga_click_id, partnero_partner) {
    if(_fbc) Axios.defaults.headers.common['X-fbc'] = _fbc;
    if(_fbp) Axios.defaults.headers.common['X-fbp'] = _fbp;
    if(_ga) Axios.defaults.headers.common['X-ga'] = _ga;
    if(ga_click_id) Axios.defaults.headers.common['X-ga-click-id'] = ga_click_id;
    if(partnero_partner) Axios.defaults.headers.common['X-partnero-partner'] = partnero_partner;
  }

  // render the routes
  return (
    <>
      <Head />
      <Elements stripe={StripePromise}>
        <MobileNavProvider>
          <AuthProvider>
            <WhitelabelProvider>
              <CopilotProvider>
                <CrispWidget />
                <FrillWidget />
                <MailCountsProvider>
                  <BrowserRouter>
                    <ActivationProvider>
                      <ActivationWidget />
                      <Suspense fallback={<Loader fullScreen />}>
                        <LazyLoadErrorBoundary>
                        <Routes>
                          <Route path="/mcp-oauth-bridge" element={<McpOauthBridge />} />
                          {routes.map((route) => {
                            return (
                              <Route
                                key={route.path}
                                path={route.path}
                                element={
                                  route.permission ? (
                                    <PrivateRoute permission={route.permission}>
                                      <View
                                        display={route.view}
                                        layout={route.layout}
                                        title={route.title}
                                      />
                                    </PrivateRoute>
                                  ) : (
                                    <View
                                      display={route.view}
                                      layout={route.layout}
                                      title={route.title}
                                    />
                                  )
                                }
                              />
                            );
                          })}

                          {/* 404 */}
                          <Route
                            path="*"
                            element={
                              <View display={NotFound} layout="home" title="404 Not Found" />
                            }
                          />
                          </Routes>
                        </LazyLoadErrorBoundary>
                      </Suspense>
                    </ActivationProvider>
                  </BrowserRouter>
                </MailCountsProvider>
                <CopilotPanel />
              </CopilotProvider>
            </WhitelabelProvider>
          </AuthProvider>
        </MobileNavProvider>
      </Elements>
    </>
  );
}
